import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Don't scroll to top if:
    // 1. There's a hash in the URL (anchor navigation)
    // 2. There's scrollToSection state (programmatic navigation to section)
    if (!location.hash && !location.state?.scrollToSection) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash, location.state?.scrollToSection]);

  return null;
}

export default ScrollToTop;